import styles from "./feature-listing-item.module.scss";

export const FeatureListingItem = ({
  title,
  hint,
  imgSrc
}: {
  title?: string,
  hint?: string,
  imgSrc?: string
}) => {
  return (
    (title || hint || imgSrc) &&
    <div className={styles['feature-listing-item']}>
      {
        imgSrc &&
        <div className={styles['feature-listing-item__icon']}>
          <img src={imgSrc} alt={title} />
        </div>
      }

      {
        (title || hint) &&
        <div className={styles['feature-listing-item__text-box']}>
          {title && <div className={styles['feature-listing-item__text-box__title']}>{title}</div>}
          {hint && <div className={styles['feature-listing-item__text-box__hint']}>{hint}</div>}
        </div>
      }
    </div>
  )
}
